import type { BoxProps } from "@amzn/storm-ui";
import { Box, Text } from "@amzn/storm-ui";
import styled from "styled-components";

import { LabelEndComponent } from "../../common/LabelEndComponent";

export interface DimensionLabelProps extends Partial<BoxProps<"div">> {
    label: string;
    tooltip?: string;
    optional?: boolean;
    "data-testid"?: string;
}
export const DimensionLabel: React.FC<DimensionLabelProps> = (props) => {
    const { label, tooltip, optional } = props;
    const defaultBoxProps: Partial<BoxProps<"div">> = {
        paddingBlockStart: "none",
        paddingBlockEnd: "xsmall",
        paddingInlineStart: "none",
        paddingInlineEnd: "none",
    };
    return (
        <Box data-testid="help" {...{ ...defaultBoxProps, ...props }}>
            <Text style={{ fontWeight: 700 }} inline>
                {label}
            </Text>
            <LabelEndComponent tooltip={tooltip} optional={optional} />
        </Box>
    );
};

export const BasicDimensionBox = styled.div`
    max-width: 300px;
`;

export const ComplexDimensionBox = styled.div`
    max-width: 800px;
`;
